export default __webpack_public_path__ + "static/media/aditya.ef6af2e8.png";